export default __webpack_public_path__ + "1c955288a77f8173f77508338c07228c.png";